var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoyaltyProgramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C15.728 15 18.75 12.09 18.75 8.5C18.75 4.91 15.728 2 12 2C8.272 2 5.25 4.91 5.25 8.5C5.25 12.09 8.272 15 12 15Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.88171C2.76499 5.05966 2 6.69377 2 8.50001C2 10.3062 2.76499 11.9403 4 13.1183",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.88171C21.235 5.05966 22 6.69377 22 8.50001C22 10.3062 21.235 11.9403 20 13.1183",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.15 6.66L12.56 5.48C12.24 4.84 11.72 4.84 11.43 5.48L10.84 6.66C10.76 6.82 10.55 6.98 10.37 7.01L9.3 7.19C8.62 7.31 8.46 7.8 8.95 8.29L9.78 9.12C9.92 9.26 9.99 9.54 9.95 9.73L9.71 10.76C9.52 11.57 9.95 11.88 10.67 11.46L11.67 10.87C11.7716 10.8158 11.8849 10.7875 12 10.7875C12.1151 10.7875 12.2284 10.8158 12.33 10.87L13.33 11.46C14.05 11.89 14.48 11.57 14.29 10.76L14.05 9.73C14 9.53 14.08 9.26 14.22 9.12L15.05 8.29C15.54 7.8 15.38 7.3 14.7 7.19L13.63 7.01C13.44 6.98 13.23 6.82 13.15 6.66Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52 13.52L7.51 20.9C7.51 21.8 8.14 22.24 8.92 21.87L11.6 20.6C11.82 20.49 12.19 20.49 12.41 20.6L15.1 21.87C15.87 22.23 16.51 21.8 16.51 20.9V13.34",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyProgramIcon);
export default __webpack_public_path__ + "static/media/loyalty_program-icon.720bc7e0ee24dfa46140a4ee33aed3cc.svg";
export { ForwardRef as ReactComponent };